import { cloneDeep } from "lodash";

export const removeContent = ({ contents, contentId }) => {
  const arr = [...contents];

  return cloneDeep(arr.filter(({ id }) => id !== contentId));
};

export default removeContent;
